<template>
  <div
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true">
    <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!--
        Background overlay, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100"
          To: "opacity-0"
      -->
      <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true">

      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true">
        &#8203;
      </span>

      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div
          class="inline-block align-bottom bg-white rounded-lg  text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-96 min-w-max">
        <div
            class="w-100">
          <div
              class="bg-brand-dark pl-5 align-middle flex h-10">
            <h1
                class=" text-white leading-10 text-lg">
              Edit User
            </h1>
            <button
                @click="$emit('bam:closed')"
                class="bg-brand-danger text-white ml-auto">
              <XIcon
                  class="h-5 w-10" />
            </button>
          </div>
        </div>
        <div
            class="flex flex-col px-5 my-5 gap-4">
          <div>
            <label
                for="email">
              Email
            </label>
            <input
                type="text"
                v-model="user.email"
                name="email"
                class="native-text-input" />
            <div
                v-for="error in v$.user.email.$silentErrors"
                :key="error.$uid"
                class="error-msg mt-1 ml-5 text-red-500 font-bold">
              <small>
                {{ error.$message }}
              </small>
            </div>
          </div>
          <div
              v-if="roles.length > 0"
              class="mt-2">
            <label
                for="roles"
                class="native-select-label">
              Role
            </label>
            <select
                v-model="user.role"
                class="native-select">
              <option
                  v-for="role in roles"
                  :value="role">{{ role }}
              </option>
            </select>
          </div>
          <div
              class="mt-3">
            <primary-button
                :disabled="v$.$invalid"
                @click="handleUpdateUser"
                text="Update User" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XIcon } from '@heroicons/vue/solid'
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import useVuelidate from "@vuelidate/core";
import {email, required} from "@vuelidate/validators";

export default {
  name: "EditUserWindow",
  components: {
    XIcon,
    PrimaryButton,
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  props: [
      'user'
  ],
  methods: {
    async handleUpdateUser() {
      try {
       await this.$store.dispatch('updateUser', this.user)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'User successfully updated!'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.commit('clearActiveUser')
      this.$emit('user:updated')
    }
  },
  computed: {
    roles() {
      return this.$store.getters.getRoles
    }
  },
  validations: {
    user: {
      email: { required, email }
    }
  },
  emits: ['user:updated', 'bam:closed']
}
</script>

<style scoped>

</style>